import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Privacy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-container">
      <h1>Privacy Policy</h1>
      <p><span className="gold-text">InazumaDle</span> does not collect or store any personal data.</p>
      <p>To enhance your gameplay experience, we use:</p>
      <p><strong>Local Storage</strong>: Stores your game progress only on your device.</p>
      <p><strong>Session Cookies</strong>: For basic game functionality. No tracking or analytics are implemented.</p>
      <p>All data remains exclusively on your device and is automatically deleted if you clear your browser storage.</p>
      <p>If you have any questions, you can contact me at <span className="gold-text">inazumadlegame@gmail.com</span>.</p>
      <p>You can go back to the game clicking <Link to="/" className="support-link">here</Link>.</p>
      <img 
        src="/images/mark.png" 
        alt="Mark" 
        className="aboutprivacyimage"
      />
    </div>
  );
}
